<div class="sentiment-analysis__summary-generator" *ngIf="config.features.showSummaryGenerator">
  <app-sentiment-summary-generator-widget
    [showOnlyActionableFilter]="!config.insightsSummaryIsPrecomputed"
    [onlyActionable]="onlyActionable"
    (onlyActionableChange)="onlyActionableChange.emit($event)"
    [selectedSentiment]="selectedSentiment"
    (selectedSentimentChange)="selectedSentimentChange.emit($event)"
    [sentimentOptions]="sentimentOptions"
    [selectedThemeId]="selectedThemeId"
    (selectedThemeIdChange)="selectedThemeIdChange.emit($event)"
    [themes]="themes"
    [summaryText]="summaryText"
    [summaryTopIssues]="summaryTopIssues"
    [summaryNextSteps]="summaryNextSteps"
    [summaryStats]="summaryStats"
    [generating]="generating"
    [loadingSummary]="loadingSummary"
    (generate)="generate.emit()"
  ></app-sentiment-summary-generator-widget>
</div>
<div *ngIf="!config.features.showSummaryGenerator" class="sentiment-analysis__verbatim-placeholder">
  <h3 class="sentiment-analysis__placeholder-title">{{ config.tabs.summary.label }}</h3>
  <p>{{ config.copy.noFeedback }}</p>
</div>
